<script>
  import { SHUFFLE_ICON } from "@utils/icons.js";
  import { Button } from "paxray-components-svelte";

  export let visible = false;
</script>

{#if visible}
  <div class="random_answer_button">
    <Button
      kind="secondary"
      text="Random answer"
      icon={SHUFFLE_ICON}
      iconLeft
      on:click
    />
  </div>
{/if}

<style>
  .random_answer_button {
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    z-index: 20;
  }

  .random_answer_button :global(.mainbutton) {
    height: 2.75rem !important;
    min-width: 0;
    padding: 0.65rem 0.9rem !important;
    gap: 0.5rem;
    font-size: 0.75rem;
    white-space: nowrap;
    box-shadow: none;
  }
</style>
